<template>
	<Container>
		<TopBar/>
		<div class="content">
			<Video class='video' :src='file.URL' :seekable='true' :pic='file.CoverURL'/>
			<div class="desc">
				<div class="buttons">
					<a :href='file.MiniDownloadURL' v-if='file.MiniDownloadURL' class="button button-primary"><Icon type="md-download" size='16'/> 保存小样</a>
					<a @click='download(file)' class="button button-primary"><Icon type="md-download" size='16'/> 下载源文件</a>
				</div>
				<p class="title">基本信息</p>
				<p class="name">名称：{{file.Name}}</p>
				<p class="spec">规格：{{file.Specification}}</p>
				<p class="size">大小：{{file.Size|sizeFormat}} <!-- - {{file.Extension}} --></p>
				<p class="duration" v-if='file.MediaType == "video"'>时长：{{file.Duration | format}}</p>
				<template v-if='file.Tags'>
					<p class="title">关键字</p>
					<div class="tags">
						<Tag size='large' v-for='tag in file.Tags.split(",")'>{{tag}}</Tag>
					</div>
				</template>
        	<div class="b-desc">
			<div v-html='file.Content'>
        
      </div>
		</div>
			</div>
		</div>
	</Container>
</template>

<script>
	import Video from '@/components/common/Video'
	import TopBar from '@/components/common/TopBar'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				file:{},
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		filters:{
			format(value){
				if(value < 0)return '00:00'
				let hour = parseInt(value / 3600)
				let minute = parseInt((value - hour * 3600) / 60)
				let second = parseInt(value - hour * 3600 - minute * 60)
				if(hour)return `${hour > 9?hour:'0'+hour}:${minute > 9 ? minute:'0'+minute}:${second > 9 ? second : '0'+second}`
				return `${minute > 9 ? minute:'0'+minute}:${second > 9 ? second :'0'+second}`
			},
			sizeFormat(value){
				if (value > 1024 * 1024) return (value * 1.0 / 1024 / 1024).toFixed(2) + 'MB'
				if (value > 1024) return (value * 1.0  / 1024).toFixed(2) + 'KB'
				return value + 'B'
			}
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			Video,
			TopBar,
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getFileDetailAction',
				'reportFileDownloadAction',
				'reportFileBrowseAction',
			]),
			async initData(){
				let {file} = this.getParams()
				this.file = file
				let code = this.$route.query?.code
				this.file = await this.getFileDetailAction({
					code,
					flag:0,
				})
			},
			download(file){
				this.reportFileDownloadAction({code:file.Code,flag:2})
				var link = document.createElement('a');
				//设置下载的文件名
				link.setAttribute("download", file.Name);
				link.style.display = 'none';
				//设置下载路径
				link.href = file.DownloadURL;
				//触发点击
				document.body.appendChild(link);
				link.click();
				//移除节点
				document.body.removeChild(link);
			}
		},
	}
</script>

<style lang='scss' scoped>
@import '@/style/common';
	@import '@/style/mixin';
	.title {
		@include fontSize($font-size-20);
		text-align: center;
		margin:20px 0;
	}
	.b-desc {
		max-width: 1440px;
		line-height: 30px;
		@include fontSize($font-size-15);
		word-break: break-all;
		margin: 10px 0;
	}
	.content {
		display:flex;
		margin:40px auto;
		max-width: 1440px;
		.video {
			max-width: 1066px;
			max-height: 600px;
			width:80vw;
			height:45vw;
		}
		.desc {
			flex:1;
			padding:20px;
			display:flex;
			border: 1px solid #ccc;
			border-left: none;
			flex-direction: column;
			// background-color: #f0f0f0;
			.title {
				text-align: left;
				margin:10px 0	;
			}
			.buttons {
				display:flex;
				flex-direction: column;
			}
			.button {
				width:200px;
				height:40px;
				@include fontSize($font-size-15);
				margin-bottom: 20px;
				align-self: center;
			}
			.name,.spec,.size,.duration {
				@include fontSize($font-size-15);
				margin-bottom: 10px;
			}
			.tags {
				display:flex;
				flex-wrap: wrap;
				// padding:4px 0;
				.tag {
					margin-right: 20px;
					padding:0 20px;
				}
			}
		}
	}
	@media (max-width: 1440px) {
		.content {
			width:90%;
		}
	}
	@media (max-width: 1200px) {
		.content {
			flex-direction: column;
			align-items: center;
			.desc {
				border-left: 1px solid #ccc;
				width:80vw;
				.buttons {
					flex-direction: row;
				}
				.button {
					margin-right: 30px;
					align-self: flex-start;
				}
			}
		}
	}
	@media (max-width: 800px) {
		.content {
			flex-direction: column;
			align-items: center;
			width:100%;
			.video {
				width:100vw;
				height:56.25vw;
			}
			.desc {
				border-left: 1px solid #ccc;
				width:100%;
				.button {
					align-self: flex-start;
				}
			}
		}
	}
	
</style>
